import $ from "jquery";
import setState from "../modules/set-state";
import spookCommand, {request} from "../modules/request";
import {goDetail, detailParam, goLanding} from "../modules/transition";
import {calcDayOffset, dateArrayToHash} from "../modules/util";
import {makeCalendars} from "../modules/calendar";
import serverParam from "./server-param";

/*
 * DOMイベントが呼ぶ関数群
 */
var Action = {
	init: function(ev) {
		const store = ev.data;
		store.def = {};
		store.params = {};
		request("LandingDecoder", {
			callback: function(data) {
				Object.assign(store.def, data);
				Object.assign(store.params, serverParam.params);
				store.def.contextPath = serverParam.contextPath;
				store.def.appBase = serverParam.appBase;
				store.def.calendarHash = dateArrayToHash(store.def.calendar);
				store.def.startDate = store.def.calendar[calcDayOffset(data.dataVersion[0], data.decodeTime[0])];
				const lastDate = store.def.calendar[store.def.calendar.length - 1];
				store.def.months = makeCalendars(store.def.startDate.code, lastDate.code);
				store.state.set({"init": true});
				store.state.set({"Count": window.__forcia__.meta}); //FIX window から取得しない
				store.state.set({"courseList": window.__forcia__.courseList}); // FIX window から取得しない
			}
		});
	},
	setState: setState,
	searchKeyword: function(ev) {
		const params = ev.data.params;
		if (params.keyword) {
			params.keyword = ""; // キーワード削除ボタンに対応、キーワード未設定で遷移する
		} else {
			params.keyword = $(".forcia-keyword")[0].value;
		}
		params.page = ""; // 1ページ目に遷移
		goLanding(params, ev.data.def.contextPath);
	},
	openCourseCalendar: function(ev) {
		ev.data.state.set({
			courseCalendarLayer: true,
			courseListIndex: $(this).data("courseListIndex")
		});
	},
	goDetail: function(ev) {
		const param = $(this).data("param");
		goDetail(param, ev.data.def.contextPath);
	},
	goDetailCalendar: function(ev) {
		const date = $(this).data("date");
		const yyyymmdd = date.replace(/-/g, "");
		const courseIndex = ev.data.state.courseListIndex; // カレンダーを開くとsetされるindex
		const course = ev.data.state.courseList[courseIndex];
		const param = detailParam(course);
		spookCommand(ev.data, "JumpRecord", {key: param.courseKey});
		goDetail(Object.assign({yyyymmdd}, param), ev.data.def.contextPath);
	}
};

if (typeof module !== "undefined" && module.exports) {
	module.exports = Action;
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/landing/action.js